import { columnTypes } from '../../constants/globals';
import { userActions } from '../../constants/user-actions';

export const tableConfig = (props) => {
  const {
    editAdminFilterAction,
    editAdminTableAction,
    allowedActions,
    editAdminTableActionsAction,
  } = props || {};

  const showEditAdministrationFilterColumn = allowedActions.includes(
    userActions.ADMINISTRATION_FILTER_UPDATE
  );

  const showEditAdministrationTableColumn = allowedActions.includes(
    userActions.ADMINISTRATION_TABLE_UPDATE
  );

  const showEditTableActionsAdministration = allowedActions.includes(
    userActions.ADMINISTRATION_TABLE_ACTIONS_UPDATE
  );

  return {
    columns: [
      {
        key: 'label',
        width: '',
        className: '',
        type: columnTypes.value,
      },
      {
        key: 'filters',
        width: '18%',
        className: 'text-center',
        type: columnTypes.action,
        onClick: editAdminFilterAction,
        icon: 'fas fa-filter fa-2x',
        condition: () => showEditAdministrationFilterColumn,
      },
      {
        key: 'table',
        width: '18%',
        className: 'text-center',
        type: columnTypes.action,
        onClick: editAdminTableAction,
        icon: 'fas fa-table fa-2x',
        condition: () => showEditAdministrationTableColumn,
      },
      {
        key: 'actions',
        width: '18%',
        className: 'text-center',
        type: columnTypes.action,
        onClick: editAdminTableActionsAction,
        icon: 'fas fa-gears fa-2x',
        condition: () => showEditTableActionsAdministration,
      },
    ],
  };
};
